import axios from 'axios';
import { ACCESS_TOKEN, config } from '../config/Config';

const sendRequest = (options) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append('Authorization', `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`);
  }

  const defaults = { headers };
  options = { ...defaults, ...options };

  return fetch(options.url, options)
    .then(
      (response) => response.json()
        .then(
          (json) => {
            if (!response.ok) {
              return Promise.reject(json);
            }
            return json;
          },
        ),
    );
};
// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL_ACTUATOR,
});

const appInstance = axios.create({
  baseURL: config.url.API_BASE_URL,
});

export function checkHealth() {
  return instance.get('/health', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}
export function getHttpTraces() {
  return instance.get('/httptrace', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}
export function getApiUptime() {
  return instance.get('/metrics/process.uptime', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getJvmMemUsed() {
  return instance.get('/metrics/jvm.memory.used', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getJvmMemMax() {
  return instance.get('/metrics/jvm.memory.max', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getCpuUsage() {
  return instance.get('/metrics/system.cpu.usage', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getCpuCount() {
  return instance.get('/metrics/system.cpu.count', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getPageUsers(pageNumber, category, searchText, size = 2) {
 
  const params = new URLSearchParams();
  
  // Add page parameter (default to 0 if not provided)
  const page = pageNumber !== undefined && pageNumber !== null && !isNaN(+pageNumber) ? pageNumber : 0;
  params.append('page', page.toString());
  
  // Add size parameter
  params.append('size', size.toString());
  
  // Add text parameter if provided
  if (searchText) {
    params.append('text', searchText);
  }
  
  return appInstance.get(`gvg/secure/admin/dashboard/users/${category}?${params.toString()}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function getStatistics() {
  return appInstance.get('/secure/admin/dashboard/statistics', {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}

export function requestChangeRole(email, role) {
  return sendRequest({
    url: `${config.url.API_BASE_URL}/secure/admin/roleChange/${email}/${role}`,
    method: 'POST',
  });
}

export function deleteEndPoint(removeEndPoint, category) {
  return appInstance.delete(`/secure/admin/deleteContent/${removeEndPoint}/${category}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}
export function salaryGeneration(salaryRequest) {
  return instance.post('/secure/admin/salaryStatementGeneration/{userName}/{month}', salaryRequest, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}
export function documentGeneration(offerLetterRequest) {
  return instance.post('/secure/admin/offerLetterGeneration', offerLetterRequest, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
    },
  });
}
export function getClients(searchText) {
 
  return appInstance.get(
    `/secure/admin/dashboard/users/client?page=0`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}

export function experienceLetterGeneration(exitEmployeeDetails) {
  return appInstance.post('/api/org/generateExperienceLetter', exitEmployeeDetails, {
      headers: { "Content-type": "application/json",
        "Authorization":localStorage.getItem(ACCESS_TOKEN)?"Bearer " +localStorage.getItem(ACCESS_TOKEN):null }
    })

}

//chit data 
export function createChitOnboard(chitPayload) {
  return appInstance.post('/gvg/secure/admin/createChitOnboard', chitPayload, {
    headers: {
      'Content-Type': 'application/json', // Adjust if needed
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}




export function createGoldOnboard(goldPayload) {
  return appInstance.post('/gvg/secure/admin/createGoldChitOnboard', goldPayload, {
    headers: {
      'Content-Type': 'application/json', // Adjust if needed
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function joinGoldChitForAdmin(goldPayload,email) {
  return appInstance.post(`/gvg/secure/admin/joinGoldChitForAdmin/${email}`, goldPayload, {
    headers: {
      'Content-Type': 'application/json', // Adjust if needed
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function joinPersonalLoanForAdmin(loanPayload,email) {
  return appInstance.post(`/gvg/secure/admin/joinPersonalLoanForAdmin/${email}`, loanPayload, {
    headers: {
      'Content-Type': 'application/json', // Adjust if needed
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}

export function updateApplicantData(putPayload) {
  return appInstance.put(`/gvg/secure/admin/updateApplicantData`, putPayload, {
    headers: {
      'Content-Type': 'application/json', // Adjust if needed
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}

// Add this constant at the top of your file

export const updateUserRole = async (payload) => {
    try {
        const response = await axios.put(`${config.url.API_BASE_URL}/gvg/secure/admin/updateRole`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Server error:', error.response.status, error.response.data);
            throw new Error(error.response.data.message || `Server error: ${error.response.status}`);
        } else if (error.request) {
            console.error('Network error:', error.request);
            throw new Error('Network error: Unable to connect to server');
        } else {
            console.error('Error:', error.message);
            throw error;
        }
    }
};